import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgArrowExit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M6.842 5.008L5.667 3.833 1.5 8l4.167 4.167 1.175-1.175-2.15-2.159h8.058V7.167H4.692l2.15-2.159zM13.833.5H2.167C1.242.5.5 1.25.5 2.167V5.5h1.667V2.167h11.666v11.666H2.167V10.5H.5v3.333c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V2.167C15.5 1.25 14.75.5 13.833.5z"
	}) })
});
export default SvgArrowExit;
